export default "__VITE_ASSET__DUi$3f22__"